export class StickyHeaderUpdater {
  constructor() {
    // Inicializace elementů
    this.adminBar = document.querySelector('#wpadminbar');
    this.headerSticky = document.querySelector('.header-sticky');

    // Váže metodu 'updateStickyTop' na aktuální kontext 'this'
    this.updateStickyTop = this.updateStickyTop.bind(this);

    // Aktualizuje CSS proměnnou při načtení
    this.updateStickyTop();

    // Přidává posluchače událostí
    window.addEventListener('resize', this.updateStickyTop);
  }

  updateStickyTop() {
    // Vypočítá pozici spodní hrany elementu 'header-sticky' jako součet jeho pozice a výšky
    const stickyBottomPosition = (this.adminBar ? this.adminBar.offsetHeight : 0) + this.headerSticky.offsetHeight;

    // Nastaví CSS proměnnou '--sticky-top' pro element 'header-sticky'
    document.documentElement.setAttribute('style', '--sticky-top:'+stickyBottomPosition+'px;');
  }

  // Volitelně, metoda pro odstranění posluchačů, pokud je to potřeba
  destroy() {
    window.removeEventListener('resize', this.updateStickyTop);
  }
}

// Vytvoření instance třídy a spuštění
document.addEventListener("DOMContentLoaded", function(){
  const stickyHeaderUpdater = new StickyHeaderUpdater();
})
